<!-- data-cs-name-owner keeps the capture-cover directive from naming this button after the host's text, which is only a badge count; the name comes from ariaLabel -->
<button cs-capture-cover data-cs-name-owner [attr.aria-label]="ariaLabel || null" [attr.aria-pressed]="pressed ?? null"></button>
<cs-icon [name]="icon" [fill]="fill"></cs-icon>
@if (badge >= badgeMinimum) {
  <span class="badge" [attr.data-position]="badgePosition" data-e2e="icon-button-badge">{{ badge }}</span>
}
